export const getAddToListMessage = (selectedItemsCount) => {
  // Validate selectedItemsCount parameter
  const isValidNumber = typeof selectedItemsCount === 'number'
    && !Number.isNaN(selectedItemsCount)
    && Number.isFinite(selectedItemsCount);

  // If invalid number, treat as 0 (disabled state)
  if (!isValidNumber) {
    return {
      priceMessage: '',
      isDisabled: true,
      atlMessage: 'Add to List'
    };
  }

  // Ensure non-negative integer by taking absolute value and flooring
  const validCount = Math.max(0, Math.floor(selectedItemsCount));

  const message = {
    isDisabled: false,
    atlMessage: 'Add to List'
  };

  if (validCount === 0) {
    message.priceMessage = '';
    message.isDisabled = true;
  } else {
    message.priceMessage = 'Subtotal:';
    if (validCount > 1) {
      message.atlMessage = `Add ${validCount} Items to List`;
    }
  }
  return message;
};

export const getItemsWithSeePriceInCartCount = (data) => {
  const currentCheckedItems = data?.filter((item) => item.checked);
  return currentCheckedItems?.filter(
    (item) => (item?.pricing?.mapScenario || item?.pricing?.message === 'see final price in cart')).length;
};

export const getMapAboveOriginal = (items = []) => {
  const messageAndQuantity = {
    mapAboveOriginalPrice: false,
    quantityLimit: 0
  };
  items.forEach((item) => {
    if (!item.checked) {
      return;
    }
    if (item?.pricing?.message === 'see final price in cart' && item?.pricing?.mapAboveOriginalPrice) {
      messageAndQuantity.mapAboveOriginalPrice = true;
    }
    if (item?.product?.info?.quantityLimit > 0) {
      messageAndQuantity.quantityLimit = item?.product?.info?.quantityLimit;
    }
  });
  return messageAndQuantity;
};

export const getTotalPrice = (items = []) => {
  const currentCheckedItems = items.filter((item) => item.checked);
  const hidePromotionDetails = currentCheckedItems.some((item) => !item?.pricing?.original);
  let originalPriceTotal = 0;
  let dollarOffTotal = 0;
  let percentageOffTotal = '0';

  if (!hidePromotionDetails) {
    // originalPrice total
    originalPriceTotal = currentCheckedItems.reduce((acc, item) => {
      return acc + (item?.pricing?.original ?? item?.pricing?.value);
    }, 0);
    originalPriceTotal = parseFloat(originalPriceTotal.toFixed(2));
    // dollarOff total
    dollarOffTotal = currentCheckedItems.reduce((acc, item) => {
      const dollarOff = item?.pricing?.promotion?.dollarOff
        ? item?.pricing?.promotion?.dollarOff
        : 0;
      return acc + dollarOff;
    }, 0);
    dollarOffTotal = parseFloat(dollarOffTotal.toFixed(2));
    // percentageOff total
    if (originalPriceTotal === 0) {
      percentageOffTotal = currentCheckedItems.length === 0 ? '0' : '100';
    } else {
      percentageOffTotal = (dollarOffTotal / originalPriceTotal) * 100;
      percentageOffTotal = percentageOffTotal.toFixed();
    }
  }

  // specialPrice total
  let valuePriceTotal = currentCheckedItems.reduce((acc, item) => {
    return acc + (item?.pricing?.value || 0);
  }, 0);
  valuePriceTotal = parseFloat(valuePriceTotal.toFixed(2));
  // pricingMessage - handle multiple pricing messages appropriately
  let pricingMessage = {};
  const pricingMessages = new Set();
  let hasMapDetail = false;

  // Collect all unique pricing messages and check for map details
  currentCheckedItems.forEach((item) => {
    if (item?.pricing?.message) {
      pricingMessages.add(item.pricing.message);
      if (item?.pricing?.mapDetail && !hasMapDetail) {
        pricingMessage.mapDetail = item.pricing.mapDetail;
        hasMapDetail = true;
      }
    }
  });

  // Determine final pricing message based on priority
  const seeFinalPriceMsgCount = getItemsWithSeePriceInCartCount(currentCheckedItems);
  if (seeFinalPriceMsgCount > 0 || pricingMessages.has('see final price in cart')) {
    pricingMessage.message = 'see final price in cart';
  } else if (pricingMessages.size === 1) {
    // Single consistent message across all items
    pricingMessage.message = Array.from(pricingMessages)[0];
  } else if (pricingMessages.size > 1) {
    // Multiple different messages - use a generic message or prioritize certain messages
    // You may want to customize this logic based on your business requirements
    pricingMessage.message = 'mixed pricing';
  }

  const mapAboveOriginalData = getMapAboveOriginal(items);

  return {
    pricing: {
      original: originalPriceTotal,
      promotion: {
        dollarOff: dollarOffTotal,
        percentageOff: percentageOffTotal
      },
      ...(!pricingMessage?.message ? { value: valuePriceTotal } : {}),
      message: pricingMessage?.message || '',
      mapDetail: pricingMessage?.mapDetail,
      mapAboveOriginalPrice: mapAboveOriginalData.mapAboveOriginalPrice,
      quantityLimit: mapAboveOriginalData.quantityLimit
    }
  };
};
